import { PLACE_ORDER, PND_PLACE_ORDER, PND_CART_DETAILS } from "./actionTypes";

const initialState = {
    checkout: [],
    pnd_cart_details: [],
    pnd_checkout: []
};

export default function(state = initialState, action) {
    switch (action.type) {
        case PLACE_ORDER:
            return { ...state, checkout: action.payload };
        case PND_CART_DETAILS:
            return { ...state, pnd_cart_details: action.payload };
        case PND_PLACE_ORDER:
            return { ...state, pnd_checkout: action.payload };
        default:
            return state;
    }
}
